import { ControlOutlined, FlagOutlined, LayoutOutlined, UserOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

import { PureTable } from '../../../../../common/ui/pure-table/pure-table'
import { RolesActionsDropdown } from '../../../../roles/roles/components/roles-actions-dropdown'
import { RolesAuthorization } from '../../../../roles/roles/components/roles-authorization'
import { Role } from '../../../../roles/roles/types/roles-page-types'

interface RolesModalProps {
  roles: Role[]
  initialRoles: Role[]
  onDelete: (roleId: number) => void
  setIsRoleModalOpen: (isOpen: boolean) => void
  setname: (name: string) => void
}

export const RolesModal = ({ roles, initialRoles, onDelete, setIsRoleModalOpen, setname }: RolesModalProps) => {
  const { t } = useTranslation()

  const columns = [
    {
      title: 'Role Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Authorizations',
      key: 'authorizations',
      render: () => {
        const { t } = useTranslation()

        return <span className="mb-0 me-2">{t('rolesPage.rolesPageTableRow.authorizations')}</span>
      },
    },
    {
      title: 'Tasks',
      key: 'tasks',
      render: () => (
        <RolesAuthorization
          icon={<FlagOutlined />}
          placeholder={t('rolesPage.rolesPageTableRow.authorizationsOptions.tasks')}
        />
      ),
    },
    {
      title: 'Projects',
      key: 'projects',
      render: () => (
        <RolesAuthorization
          icon={<LayoutOutlined />}
          placeholder={t('rolesPage.rolesPageTableRow.authorizationsOptions.projects')}
        />
      ),
    },
    {
      title: 'Management',
      key: 'management',
      render: () => (
        <RolesAuthorization
          icon={<ControlOutlined />}
          placeholder={t('rolesPage.rolesPageTableRow.authorizationsOptions.management')}
        />
      ),
    },
    {
      title: 'Accounts',
      key: 'accounts',
      render: () => (
        <RolesAuthorization
          icon={<UserOutlined />}
          iconPositionStart={false}
          placeholder={t('rolesPage.rolesPageTableRow.authorizationsOptions.accounts')}
        />
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: unknown, record: { id: number; name: string }) => (
        <RolesActionsDropdown
          initialRoles={initialRoles}
          name={record.name}
          onDelete={onDelete}
          roleId={record.id}
          setIsRoleModalOpen={setIsRoleModalOpen}
          setname={setname}
        />
      ),
    },
  ]

  return (
    <PureTable
      columns={columns}
      dataSource={roles}
    />
  )
}
